__turbopack_context__.v({
  "actions": "SendTipModal-module-scss-module__VlzbAG__actions",
  "amountChip": "SendTipModal-module-scss-module__VlzbAG__amountChip",
  "cancelButton": "SendTipModal-module-scss-module__VlzbAG__cancelButton",
  "chip": "SendTipModal-module-scss-module__VlzbAG__chip",
  "chipGroup": "SendTipModal-module-scss-module__VlzbAG__chipGroup",
  "currencyChip": "SendTipModal-module-scss-module__VlzbAG__currencyChip",
  "currencyChipLabel": "SendTipModal-module-scss-module__VlzbAG__currencyChipLabel",
  "iconWrapper": "SendTipModal-module-scss-module__VlzbAG__iconWrapper",
  "label": "SendTipModal-module-scss-module__VlzbAG__label",
  "presetCard": "SendTipModal-module-scss-module__VlzbAG__presetCard",
  "sendIcon": "SendTipModal-module-scss-module__VlzbAG__sendIcon",
  "submitButton": "SendTipModal-module-scss-module__VlzbAG__submitButton",
});
